import { render, staticRenderFns } from "./GCollapsible.vue?vue&type=template&id=93d65000&"
import script from "./GCollapsible.vue?vue&type=script&lang=js&"
export * from "./GCollapsible.vue?vue&type=script&lang=js&"
import style0 from "./GCollapsible.vue?vue&type=style&index=0&id=93d65000&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports